import React from 'react'
import { useStableAccessor } from '~/utils/use-stable-accessor'
type State = { lat: number; lng: number } | null

function makeExternalStore() {
  let state: State = null
  let subscribers: ((state: State) => void)[] = []
  function subscribe(onStoreChange: (state: State) => void) {
    subscribers = [...subscribers, onStoreChange]
    return () => {
      subscribers = subscribers.filter((s) => s !== onStoreChange)
    }
  }

  function select(option: Exclude<State, null>) {
    state = option
    subscribers.every((s) => s(state))
  }
  function deselect(option: Exclude<State, null>) {
    if (state?.lat === option.lat && state?.lng === option.lng) {
      state = null
      subscribers.every((s) => s(state))
    }
  }

  return {
    subscribe,
    select,
    deselect
  }
}

const hoverState = makeExternalStore()

function useOnMapHover(onChange: (state: State) => void) {
  const onChangeStable = useStableAccessor(onChange)
  React.useEffect(() => {
    const change = (state: State) => {
      onChangeStable()(state)
    }
    return hoverState.subscribe(change)
  }, [onChangeStable])
}

export const SearchMapHover = {
  useOnMapHover,
  select: hoverState.select,
  deselect: hoverState.deselect
}
